import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface FAQ2ItemProps {
  question: string;
  answer: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQ2Item({
  question,
  answer,
  isOpen,
  onToggle
}: FAQ2ItemProps) {
  return <motion.div className="bg-brand-card border border-white/10 rounded-xl overflow-hidden" initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} data-id="element-96">
      <button onClick={onToggle} className="w-full flex items-center justify-between p-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green/50" aria-expanded={isOpen} data-id="element-97">
        <span className="text-base md:text-lg font-semibold text-white pr-4" data-id="element-98">
          {question}
        </span>
        {/* Toggle switch */}
        <div className={`relative w-12 h-6 rounded-full flex-shrink-0 transition-colors duration-300 ${isOpen ? 'bg-brand-green' : 'bg-white/15'}`} data-id="element-99">
          <div className={`absolute top-0.5 w-5 h-5 rounded-full bg-white shadow-sm transition-transform duration-300 ${isOpen ? 'translate-x-6' : 'translate-x-0.5'}`} data-id="element-100" />
        </div>
      </button>
      <AnimatePresence initial={false} data-id="element-101">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="overflow-hidden" data-id="element-102">
            <div className="px-5 pb-5 text-brand-dark/60 leading-relaxed text-sm md:text-base" data-id="element-103">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}
export function FAQ2Section() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-brand-bg pt-6 md:pt-8 pb-16 md:pb-20 px-6" data-id="element-104">
      <div className="max-w-3xl mx-auto" data-id="element-105">
        <motion.h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-106">
          Preguntas frecuentes
        </motion.h2>

        <div className="flex flex-col gap-4" data-id="element-107">
          <FAQ2Item question="¿Para quién es esta guía?" answer="Para cualquier persona que quiera generar ingresos online desde cero, incluso si nunca vendiste nada. Si hoy no sabés por dónde empezar, esta guía te da un camino claro." isOpen={openIndex === 0} onToggle={() => handleToggle(0)} data-id="element-108" />
          <FAQ2Item question="¿Cuánto dura el curso?" answer="Según tu dedicación, no tiene duración fija. Avanzás a tu ritmo. Tenemos alumnos que en pocos días ya estaban aplicando y generando sus primeras ventas." isOpen={openIndex === 1} onToggle={() => handleToggle(1)} data-id="element-109" />
          <FAQ2Item question="¿Necesito experiencia previa?" answer="No. Está diseñado para empezar desde cero, paso a paso, sin conocimientos técnicos ni experiencia previa." isOpen={openIndex === 2} onToggle={() => handleToggle(2)} data-id="element-110" />
          <FAQ2Item question="¿Qué incluye exactamente?" answer={<div data-id="element-112">
                <p data-id="element-113">
                  Acceso completo a la guía +{' '}
                  <strong className="text-white" data-id="element-114">
                    actualizaciones de por vida
                  </strong>{' '}
                  👉 Y además, 3 bonos exclusivos:
                </p>
                <ul className="mt-3 space-y-1.5" data-id="element-115">
                  <li className="flex items-start gap-2" data-id="element-116">
                    <span className="text-brand-green mt-0.5" data-id="element-117">🟢</span>
                    <span data-id="element-118">Códigos de landing ganadora</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-119">
                    <span className="text-brand-green mt-0.5" data-id="element-120">🟢</span>
                    <span data-id="element-121">Mockups profesionales</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-122">
                    <span className="text-brand-green mt-0.5" data-id="element-123">🟢</span>
                    <span data-id="element-124">Estrategias para encontrar productos ganadores</span>
                  </li>
                </ul>
              </div>} isOpen={openIndex === 3} onToggle={() => handleToggle(3)} data-id="element-111" />
          <FAQ2Item question="¿Cómo accedo después de pagar?" answer="Acceso inmediato. Apenas realizás el pago, recibís todo por email para empezar al instante." isOpen={openIndex === 4} onToggle={() => handleToggle(4)} data-id="element-125" />
          <FAQ2Item question="¿Cuánto tiempo debo dedicar por día?" answer="Con 45–60 minutos diarios ya podés avanzar. Si le dedicás más tiempo, los resultados llegan más rápido." isOpen={openIndex === 5} onToggle={() => handleToggle(5)} data-id="element-126" />
        </div>

        {/* CTA Button */}
      </div>
    </section>;
}